module.exports = __webpack_public_path__ + "media/images/logo-primary-c15ac1bcc0764d0bbf738d903dc315e0.png";